import client from "./client";

export const createRazorpayOrder = async (planId) => {
  const res = await client.post("/razorpay/create-order", { planId });
  return res.data;
};

export const verifyRazorpayPayment = async (payload) => {
  const res = await client.post("/razorpay/verify", payload);
  return res.data;
};
